import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { LazyLoadModule } from 'shared/lazy-load/lazy-load.module';
import { SharedModule } from 'shared/shared.module';

import { PieceHudsonCarouselRenderComponent } from './piece-hudson-carousel-render.component';


export const pieceHudsonCarouselRenderModuleEntryComponents = [
  PieceHudsonCarouselRenderComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule,
    LazyLoadModule,
  ],
  declarations: pieceHudsonCarouselRenderModuleEntryComponents,
  providers: [
    {
      provide: 'Window',
      useValue: window
    }
  ]
})
export class PieceHudsonCarouselRenderModule {}

export default pieceHudsonCarouselRenderModuleEntryComponents;
